/* eslint-disable react/no-danger */
import { makeStyles, Theme, fade } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import { colorMap, secondaryColorMap } from '@/utils/constants';

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      ...theme.typography.body1,
      backgroundColor: 'white',
      color: colorMap.charcoal,
      textAlign: 'center',
      padding: '15px 20px',
      width: '100%',
      position: 'relative',
    },
    error: {
      '&:before': {
        content: '""',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        backgroundColor: fade(theme.palette.error.main, 0.05),
      },
    },
    message: {
      color: secondaryColorMap.dark,
    },
    errorMessage: {
      color: theme.palette.error.dark,
    },
  }),
  { name: 'GenCMSPlaceholder' },
);

const CMSPlaceholder = ({
  componentName,
  elementLabel = 'Component',
  errorMessage,
  message = '',
  contentButtons,
}: {
  componentName?: string;
  message?: string;
  elementLabel?: string;
  errorMessage?: string;
  contentButtons?: any;
}) => {
  const classes = useStyles();
  return (
    <div className={clsx(classes.root, errorMessage && classes.error, 'cms-placeholder')}>
      {contentButtons?.content}[{' '}
      <span className="click-here-placeholder">Click here to configure </span>
      <b>{componentName}</b> <span>{elementLabel}</span> ]{' '}
      {errorMessage && (
        <small className={clsx(classes.errorMessage)}>
          <i dangerouslySetInnerHTML={{ __html: errorMessage }} />
        </small>
      )}
      {!errorMessage && message && (
        <small className={clsx(classes.message)}>
          <i dangerouslySetInnerHTML={{ __html: message }} />
        </small>
      )}
    </div>
  );
};

export default CMSPlaceholder;
